export default class SwishPayment extends HTMLDivElement {

    interval = 1500;
    pollInterval = null;

    connectedCallback() {

        setTimeout(() => {
            this.pollInterval = setInterval(this.poll, this.interval);
        }, this.startDelay);

    }

    disconnectedCallback() {

        clearInterval(this.pollInterval);

    }

    poll = () => {
        fetch(`/umbraco/api/swishstatus/Get?paymentId=${this.dataset.paymentId}`)
            .then(response => response.text())
            .then((result) => {
            if (result === "WAIT") {
                //try again in interval timer!
            } else {
                var resultJson = JSON.parse(result);

                if (resultJson.paymentStatus === 1) {
                    if (resultJson.crmStatus === 1) {
                        clearInterval(this.pollInterval);
                        window.location.replace(this.dataset.successUrl);
                    }

                    if (resultJson.crmStatus === 2) {
                        clearInterval(this.pollInterval);
                        window.location.replace(this.dataset.errorUrl);
                    }
                }
                else if (resultJson.paymentStatus === 3) {
                    clearInterval(this.pollInterval);
                    window.location.replace(window.location.replace(this.dataset.declinedUrl));
                }
            }

        });
    }

    get startDelay() {
        return this.dataset.startDelay != null ? Number(this.dataset.startDelay) : 0;
    }

}

customElements.define('swish-payment', SwishPayment, { extends: 'div' });